var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img-with-loading',{attrs:{"height":'36px',"img-src":_vm.root+_vm.item[_vm.model],"width":'36px'}})
}
var staticRenderFns = []

export { render, staticRenderFns }